import { useState, useCallback } from 'react';
import { getMsalInstance, getMsalRedirectResult, loginScopes, isSsoConfigured } from './msalConfig';

export function useMsalLogin() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loginWithRedirect = useCallback(async (): Promise<void> => {
    const msal = getMsalInstance();
    if (!msal) {
      setError('SSO not configured');
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      // Ensure MSAL is initialized (reuse the module-level init if already started)
      const redirectResult = getMsalRedirectResult();
      if (redirectResult) await redirectResult;
      await msal.loginRedirect({
        scopes: loginScopes,
        prompt: 'select_account',
      });
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'SSO redirect failed';
      setError(msg);
      setIsLoading(false);
    }
  }, []);

  return {
    loginWithRedirect,
    isLoading,
    error,
    isSsoAvailable: isSsoConfigured(),
  };
}
